/* ============================================================
   [CLAUDE] Product gallery indicators | v3 2026-08-05
   - "3 / 14" photo counter on the gallery, BOTH mobile & desktop.
     MOBILE: bottom-left (favorites heart owns bottom-right).
     DESKTOP: top-left (gallery bottom sits below the fold at
     common viewport heights, so bottom placement was invisible).
   - MOBILE only: tappable dot row under the gallery.
   - DESKTOP: fade + chevron cue at the bottom of the thumbnail
     strip whenever more thumbnails exist below.
   Applies to ALL products with 2+ gallery images.
   Safety: no jQuery dependency, all in try/catch - errors leave
   the page exactly as before.
   ============================================================ */
(function () {
  'use strict';
  try {
    if (!/\/products\//.test(window.location.pathname)) return;

    var init = function () {
      var slider = document.querySelector('.product-gallery__main_slider');
      if (!slider || !slider.classList.contains('slick-initialized')) return false;
      if (slider.getAttribute('data-claude-indicators')) return true; /* already done */
      var slides = slider.querySelectorAll('.slick-slide:not(.slick-cloned)');
      var total = slides.length;
      if (total < 2) { slider.setAttribute('data-claude-indicators', '1'); return true; }
      slider.setAttribute('data-claude-indicators', '1');

      var thumbs = document.querySelector('.product-gallery__thumbnail_slider');

      var css = '' +
        '.claude-gal-counter{position:absolute;left:10px;bottom:10px;z-index:5;background:rgba(0,0,0,.55);color:#fff;font:11px/1 Arial,sans-serif;padding:6px 10px;border-radius:12px;pointer-events:none;letter-spacing:.5px}' +
        '.claude-gal-counter.claude-top{top:10px;bottom:auto}' +
        '.claude-gal-dots{display:flex;justify-content:center;gap:6px;padding:10px 6px 2px;flex-wrap:wrap}' +
        '.claude-gal-dots span{width:7px;height:7px;border-radius:50%;background:#cfcfcf;display:block;transition:background .2s,transform .2s}' +
        '.claude-gal-dots span.on{background:#2c2c2c;transform:scale(1.35)}' +
        '.claude-gal-dots span.clickable{cursor:pointer}' +
        '.claude-thumb-fade{position:absolute;left:0;right:0;bottom:0;height:52px;z-index:4;pointer-events:none;background:linear-gradient(to bottom,rgba(255,255,255,0),rgba(255,255,255,.95));display:flex;align-items:flex-end;justify-content:center}' +
        '.claude-thumb-fade:after{content:"";width:9px;height:9px;border-right:2px solid #777;border-bottom:2px solid #777;transform:rotate(45deg);margin-bottom:9px}';
      var st = document.createElement('style');
      st.textContent = css;
      document.head.appendChild(st);

      if (window.getComputedStyle(slider).position === 'static') slider.style.position = 'relative';
      var counter = document.createElement('div');
      counter.className = 'claude-gal-counter';
      slider.appendChild(counter);

      var slickApi = (slider.slick && typeof slider.slick.slickGoTo === 'function') ? slider.slick : null;

      var dots = document.createElement('div');
      dots.className = 'claude-gal-dots';
      var makeDot = function (idx) {
        var d = document.createElement('span');
        if (slickApi) {
          d.className = 'clickable';
          d.addEventListener('click', function () { try { slickApi.slickGoTo(idx); } catch (e) {} });
        }
        return d;
      };
      for (var i = 0; i < total; i++) dots.appendChild(makeDot(i));
      if (slider.parentElement) slider.parentElement.insertBefore(dots, slider.nextSibling);

      var fade = null;
      if (thumbs && thumbs.parentElement) {
        var tp = thumbs.parentElement;
        if (window.getComputedStyle(tp).position === 'static') tp.style.position = 'relative';
        fade = document.createElement('div');
        fade.className = 'claude-thumb-fade';
        tp.appendChild(fade);
      }

      var thumbsVisible = function () {
        if (!thumbs) return false;
        var r = thumbs.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      };

      var refresh = function () {
        try {
          var cur = slider.querySelector('.slick-current:not(.slick-cloned)') || slider.querySelector('.slick-current');
          var idx = cur ? parseInt(cur.getAttribute('data-slick-index'), 10) : 0;
          if (isNaN(idx)) idx = 0;
          idx = ((idx % total) + total) % total;
          counter.textContent = (idx + 1) + ' / ' + total;
          var mobile = !thumbsVisible();
          counter.style.display = 'block';
          counter.classList.toggle('claude-top', !mobile); /* desktop: top-left */
          dots.style.display = mobile ? 'flex' : 'none';
          for (var i = 0; i < dots.children.length; i++) {
            dots.children[i].classList.toggle('on', i === idx);
          }
          if (fade) {
            var show = false;
            if (!mobile) {
              var tSlides = thumbs.querySelectorAll('.slick-slide:not(.slick-cloned)');
              var box = thumbs.getBoundingClientRect();
              for (var j = 0; j < tSlides.length; j++) {
                var rr = tSlides[j].getBoundingClientRect();
                if (rr.height > 0 && rr.top > box.bottom - 10) { show = true; break; }
              }
            }
            fade.style.display = show ? 'flex' : 'none';
          }
        } catch (e) { /* never break the page */ }
      };

      refresh();
      var mo = new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          if (ms[i].attributeName === 'class') { refresh(); return; }
        }
      });
      mo.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
      if (thumbs) mo.observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('resize', refresh);
      return true;
    };

    var tries = 0;
    var t = window.setInterval(function () {
      tries += 1;
      try {
        if (init() || tries > 120) window.clearInterval(t);
      } catch (e) { window.clearInterval(t); }
    }, 250);
  } catch (e) { /* never break the page */ }
})();
